import React, { useEffect, useState } from 'react';

/**
 * Terms and Conditions page for TRUNNA order booking.
 * With HashRouter, use: https://aashman.in/#/terms-and-conditions
 */
function TermsAndConditions() {
  const [termsText, setTermsText] = useState('');
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Terms & Conditions | Aashman Technicals';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    fetch(`${process.env.PUBLIC_URL}/documents/TRUNNA-Order-Terms-and-Conditions.txt`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to load terms content');
        }
        return response.text();
      })
      .then((text) => {
        if (isMounted) {
          setTermsText(text);
        }
      })
      .catch(() => {
        if (isMounted) {
          setLoadError(
            'Unable to load Terms & Conditions content right now. Please refresh and try again.'
          );
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="privacy-policy-page" aria-labelledby="terms-page-title">
      <div className="container">
        <div className="legal-page-header">
          <h1 id="terms-page-title">Terms &amp; Conditions</h1>
          <p className="legal-page-subtitle">
            TRUNNA Order Booking - Aashman Technicals Pvt. Ltd.
          </p>
          <p className="legal-page-meta">
            Version 1.0 | Effective Date: 23 May 2026
          </p>
        </div>

        <div className="legal-page-body">
          <article className="legal-card">
            <h2>Complete Terms and Conditions</h2>
            {loadError ? (
              <p className="legal-load-error">{loadError}</p>
            ) : (
              <pre className="legal-verbatim-text">
                {termsText || 'Loading complete Terms & Conditions...'}
              </pre>
            )}
          </article>

          <div className="legal-note">
            <p>
              <strong>Important:</strong> This page is the web presentation of the official
              "TRUNNA Order Booking Terms &amp; Conditions" document. For legal proceedings,
              the signed/accepted in-app version and official company records govern.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsAndConditions;
